import AppContext from "PFApp/app_context";
import PageTabs from "PFComponents/page/page_tabs";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

import css from "./insights_page.module.scss";
import FiltersBar from "./parts/common/filters_bar";
import RolesListModal from "./parts/common/roles_list_modal";
import PlatformUsagePage from "./parts/platform_usage/platform_usage_page";
import RolesPage from "./parts/roles_analytics/roles_page";
import SkillsPage from "./parts/skills_analytics/skills_page";

const InsightsPage = () => {
  const {
    store: {
      pages: {
        insights: { tab, changeTab }
      }
    }
  } = useContext(AppContext);

  const { t } = useTranslation("insights");

  const tabs = useRef([
    { id: "roles", displayElement: t("tabs.rolesAnalytics") },
    { id: "skills", displayElement: t("tabs.skillsAnalytics") },
    { id: "platform", displayElement: t("tabs.platfomUsage") }
  ]);

  const TabComponent =
    {
      roles: RolesPage,
      skills: SkillsPage,
      platform: PlatformUsagePage
    }[tab] || RolesPage;

  return (
    <>
      <div className={css.wrap}>
        <PageTabs
          items={tabs.current}
          handleClick={(value) => changeTab(value.id)}
          active={tab}
          rootClassName={css.tabs}
        />
      </div>
      <FiltersBar />

      <TabComponent />
      <RolesListModal />
    </>
  );
};

export default InsightsPage;
